module.exports = __webpack_public_path__ + "media/images/gateway/shopify-5e852fad7f76029b959169fcbeb3e04b.png";